import { useEffect, useState } from "react"
import { usePrevious } from "./usePrevious";

export const useLocalStorage = () => {
    const [_localStorage, setLocalStorage] = useState<Storage>(localStorage);
    const prevStorageValue = usePrevious(JSON.stringify(_localStorage));

    useEffect(() => {
        if (JSON.stringify(localStorage) !== prevStorageValue) {
            setLocalStorage(localStorage)
        }
    }, [JSON.stringify(localStorage)]);

    return _localStorage;
}